import { isPreviewDomain } from '../../index';
import getPreviewModeFromPath from '../getPreviewModeFromPath';

export default function getPreviewPathInfo(hostname: string, path: string) {
  const isPreviewHostname = isPreviewDomain(hostname);
  const { previewMode, previewTenantDomain } = getPreviewModeFromPath(path);
  const isPreviewSite = isPreviewHostname && !!previewMode;

  return {
    isPreviewSite,
    isPreviewHostname,
    previewMode,
    previewUrlPrefix:
      previewMode && previewTenantDomain
        ? `${previewMode}/${previewTenantDomain}`
        : null,
  };
}
